import { useQuery } from 'react-query';

import { useSecurePortalFetcher } from '../hooks';
import { CurrentUser, UseReactQueryOptions } from '../models';

export const useCurrentUserQuery = (
  options?: UseReactQueryOptions<CurrentUser>
) => {
  const fetcher = useSecurePortalFetcher();

  return useQuery(
    ['currentUser'],
    async () => {
      const { data } = await fetcher<CurrentUser>('/v2/users/current').json();

      return data;
    },
    options
  );
};
